import { CheckboxContainer, Icon, StyledCheckbox } from './Checkbox_2.styles';
import { ICheckbox_2 } from './Checkbox_2.types';

export const Checkbox_2 = ({
  className,
  checked,
  onClick,
  label,
  user = 'landlord',
  alignItems,
}: ICheckbox_2) => {
  const handleOnClick = (
    event: React.MouseEvent<HTMLDivElement | HTMLLabelElement>,
  ) => {
    event.stopPropagation();
    onClick && onClick();
  };
  return (
    <CheckboxContainer
      className={className}
      onClick={handleOnClick}
      alignItems={alignItems}
    >
      <StyledCheckbox checked={checked} user={user}>
        <Icon viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      </StyledCheckbox>
      <label onClick={handleOnClick}>{label}</label>
    </CheckboxContainer>
  );
};
